const DIGIT_SENTINEL_UNREACHED = -1
const MATRIX_PREVIEW_ROWS = 3

export const isTimedMatchingGridPayload = value =>
  !!value &&
  typeof value === 'object' &&
  Array.isArray(value.correct_item_sequence) &&
  Array.isArray(value.submitted_item_sequence)

const formatItemResponse = (correctVal, submittedVal, inputType) => {
  if (submittedVal === DIGIT_SENTINEL_UNREACHED) {
    return 'Not reached'
  }
  if (inputType === 'checkmark') {
    if (submittedVal === 1) return 'Correct'
    if (submittedVal === 0) return 'Incorrect'
    return String(submittedVal)
  }
  if (submittedVal === correctVal) {
    return String(submittedVal)
  }
  return `${submittedVal} (correct: ${correctVal})`
}

const formatSummary = payload => {
  const parts = []
  if (payload.score != null) {
    parts.push(`Score: ${payload.score}`)
  }
  if (payload.items_completed != null) {
    parts.push(`Items completed: ${payload.items_completed}`)
  }
  if (payload.errors != null) {
    parts.push(`Errors: ${payload.errors}`)
  }
  if (payload.elapsed_seconds != null) {
    const unit = payload.elapsed_seconds === 1 ? 'second' : 'seconds'
    parts.push(`Elapsed: ${payload.elapsed_seconds} ${unit}`)
  }
  if (payload.timed_out) {
    parts.push('Timed out')
  }
  return parts.join(' · ')
}

/** Matrix-style view model for admin drawer (API stays kind: json). */
export const buildTimedMatchingGridMatrixView = payload => {
  if (!isTimedMatchingGridPayload(payload)) {
    return null
  }
  const inputType = String(payload.input_type || 'digit')
    .trim()
    .toLowerCase()
  const correct = payload.correct_item_sequence
  const submitted = payload.submitted_item_sequence
  const length = Math.min(correct.length, submitted.length)
  const rows = []
  for (let index = 0; index < length; index += 1) {
    rows.push({
      row_label: `Item ${index + 1}`,
      response: formatItemResponse(correct[index], submitted[index], inputType),
    })
  }
  return {
    summary: formatSummary(payload),
    rows,
    preview_count: MATRIX_PREVIEW_ROWS,
  }
}

export const formatTimedMatchingGridJsonForCsv = payload => {
  const view = buildTimedMatchingGridMatrixView(payload)
  if (!view) {
    return 'No response'
  }
  const rowText = view.rows.map(row => `${row.row_label}: ${row.response}`).join('; ')
  return view.summary ? `${view.summary}; ${rowText}` : rowText
}
